import { render, staticRenderFns } from "./ProductLabelGroup.vue?vue&type=template&id=704c4208&"
import script from "./ProductLabelGroup.vue?vue&type=script&lang=js&"
export * from "./ProductLabelGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports